import React from 'react';
import {OrbitComponent} from "../../../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    GameModeEnum,
    IGameContextViewModel
} from "../../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GamePlayPcHeaderBarTopMiddleSectionBox} from "../../../../boxes/sections/top-section/middle/game-play-pc-header-bar-top-middle-section.box";
import {GamePlayPcHeaderBarRealDemoGameModeComponent} from "./game-play-pc-header-bar-real-demo-game-mode.component";
import {
    GamePlayPcHeaderBarTopMiddleSectionContentBox
} from "../../../../boxes/sections/top-section/middle/game-play-pc-header-bar-top-middle-section-content.box";
import {GamePlayPcHeaderBarFreePlayGameModeComponent} from "./game-play-pc-header-bar-free-play-game-mode.component";


export const GamePlayPcHeaderBarTopMiddleSectionComponent = observer(
    class GamePlayPcHeaderBarTopMiddleSectionComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {

        private get _gameMode() {
            return this.props.gameContext.gameMode;
        }

        private _getCorners() {
            const gameFrameImages = this.services.theme.currentTheme.assets.images.game_frame;

            if(this.props.gameContext.freePlayContext.shouldShowFreePlayHeader) {
                return {
                    left: gameFrameImages.freeplay_left_corner_png.toString(),
                    right: gameFrameImages.freeplay_right_corner_png.toString()
                };
            }

            switch (this._gameMode) {
                case GameModeEnum.Real:
                    return {
                        left: gameFrameImages.real_left_corner_png.toString(),
                        right: gameFrameImages.real_right_corner_png.toString()
                    };
                case GameModeEnum.Demo:
                    return {
                        left: gameFrameImages.demo_left_corner_png.toString(),
                        right: gameFrameImages.demo_right_corner_png.toString()
                    };
                default:
                    return {
                        left: "",
                        right: ""
                    };

            }
        }

        private _renderGameMode() {
            if(this.props.gameContext.freePlayContext.shouldShowFreePlayHeader) {
                return (<GamePlayPcHeaderBarFreePlayGameModeComponent gameContext={this.props.gameContext}/>);
            }

            if(!this.props.gameContext.allowSwitchBetweenDemoAndReal) {
                return null;
            }

            return (
                <GamePlayPcHeaderBarRealDemoGameModeComponent gameMode={this._gameMode}/>
            );
        }

        render() {

            const gameModeComponent = this._renderGameMode();

            if(!gameModeComponent) {
                return null;
            }

            const corners = this._getCorners();

            return (
                <GamePlayPcHeaderBarTopMiddleSectionBox>
                    <GamePlayPcHeaderBarTopMiddleSectionContentBox leftCornerImageUrl={corners.left} rightCornerImageUrl={corners.right}>
                        {gameModeComponent}
                    </GamePlayPcHeaderBarTopMiddleSectionContentBox>
                </GamePlayPcHeaderBarTopMiddleSectionBox>

            )
        }
    }
);